module.exports = __webpack_public_path__ + "static/media/how-it-works-filters-1.5b6ce086.png";